/**
 * @copyright 2019 @ DigiNet
 * @author tranghoang
 * @create 2019/08/05 18:12
 * @update 2019/08/05 18:12
 */

module.exports = {
    api: process && process.env && process.env.REACT_APP_API ? process.env.REACT_APP_API : 'https://apricot.diginet.com.vn/lpt-api-dev',
    url: process && process.env && process.env.REACT_APP_WEB ? process.env.REACT_APP_WEB : 'https://apricot.diginet.com.vn/erp-dev',
    secret : process && process.env && process.env.REACT_APP_SECRET ? process.env.REACT_APP_SECRET :  'd9hc5d0k5LnJx9Cvk9NwOe3uGy0cW9ja2kv3dg',

    cdn: process && process.env && process.env.REACT_APP_CDN_URL ? process.env.REACT_APP_CDN_URL : 'https://apricot.diginet.com.vn/cdn-dev',
    secretCDN : process && process.env && process.env.REACT_APP_CDN_SECRET ? process.env.REACT_APP_CDN_SECRET :  'd3hc5d0k5LnJx9Cvq3NwOe3uGy0cW9ja2kv3dg',

    prefixLang : process && process.env && process.env.REACT_APP_PREFIXLANG ? process.env.REACT_APP_PREFIXLANG :  'ERP_',
    companyCode : process && process.env && process.env.REACT_APP_COMPANYCODE ? process.env.REACT_APP_COMPANYCODE :  'APRICOT',
    productID : process && process.env && process.env.REACT_APP_PRODUCTID ? process.env.REACT_APP_PRODUCTID :  'WERP',

    mookAPI: process && process.env && process.env.REACT_APP_MOOK_API ? process.env.REACT_APP_MOOK_API :  'NO',
    keyEnv: process && process.env && process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV :  'NO',
};
